import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { SUBSCRIPTION_STATES } from 'constants/subscriptions';

export const checkSubscriptionsWithReminders = (externalIds: string[]) => (subscriptions: ISubscriptionWellfunnel[]) =>
    externalIds.every((externalId) =>
        subscriptions.some((subscription) => subscription.external_id === externalId && subscription.reminder)
    );

export const checkAllCancelledSubscriptions =
    (cancellationCandidates: ISubscriptionWellfunnel[]) => (subscriptions: ISubscriptionWellfunnel[]) =>
        cancellationCandidates.every((candidate) =>
            subscriptions.some(
                (subscription) =>
                    subscription.id === candidate.id &&
                    (!!subscription.cancelled_at || !!subscription.internal_cancel_at)
            )
        );

export const checkAllSubscriptionsWithDiscount = () => (subscriptions: ISubscriptionWellfunnel[]) =>
    subscriptions.some(({ discount: { discount_type } }) => discount_type);

export const checkAllPausedSubscriptions = (externalIds: string[]) => (subscriptions: ISubscriptionWellfunnel[]) =>
    externalIds.every((externalId) =>
        subscriptions.some(
            (subscription) =>
                subscription.external_id === externalId && subscription.state === SUBSCRIPTION_STATES.Paused
        )
    );

export const checkAllResumedSubscriptions = (externalId: string) => (subscriptions: ISubscriptionWellfunnel[]) =>
    subscriptions.some(({ external_id, state }) => external_id === externalId && state === SUBSCRIPTION_STATES.ACTIVE);

export const checkSubscriptionRestored = (externalId: string) => (subscriptions: ISubscriptionWellfunnel[]) =>
    subscriptions.some(
        ({ external_id, internal_cancel_at, cancelled_at }) =>
            external_id === externalId && !internal_cancel_at && !cancelled_at
    );
